@if ((hubsState | async)?.isLoading || selectedGroupId) {
  <div
    [@fadeInEnter]
    [ngStyle]="{ top: 0, left: 0, right: 0 }"
    class="u-position-absolute"
  >
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
} @else if (1 < (joinableHubs | async)?.length) {
  @if (tenant?.enabled_features?.new_onboarding) {
    <app-onboarding-background-flair [ngStyle]="{ 'z-index': 0 }" />
  }
  <div
    [infiniteScrollDistance]="5"
    [infiniteScrollThrottle]="10"
    [ngStyle]="{
      overflowY: 'auto',
    }"
    (scrolled)="loadMoreHubs()"
    class="u-padding-40-0"
    infiniteScroll
  >
    <div
      [ngStyle]="{
        width: '936px',
        maxWidth: '95vw',
        'z-index': 5,
      }"
      class="u-margin-center u-position-relative"
    >
      <div class="u-marginBottom-32 u-paddingBottom-16 u-textAlign-center">
        <app-avatar-tenant
          [item]="tenant"
          [size]="96"
          class="u-display-inlineBlock u-marginBottom-16"
        >
        </app-avatar-tenant>
        <h5
          i18n="@@userOnboardingView.hubs.title"
          class="u-textDecoration-bold"
        >
          Join a community hub
        </h5>
      </div>
      <div
        fxLayout="column"
        fxLayout.gt-xs="row wrap"
        fxLayoutAlign="start center"
        fxLayoutGap.gt-xs="2%"
      >
        @for (hub of joinableHubs | async; track hub._id) {
          <div
            [ngClass]="{ 'mat-elevation-z5': hoverStates['hub-' + hub._id] }"
            [ngStyle]="{ 'z-index': 5 }"
            (mouseleave)="hoverStates['hub-' + hub._id] = false"
            (mouseover)="hoverStates['hub-' + hub._id] = true"
            class="u-display-block u-width-100 bg-color-white u-marginBottom-16 u-borderRadius-inner-card mat-elevation-z1 u-border-grey100"
            fxFlex="100%"
            fxFlex.gt-xs="48%"
          >
            <button
              (click)="navigateToNextView.emit(hub)"
              class="c-button u-width-100"
            >
              <app-hub-card
                [group]="hub"
                class="u-display-block"
              ></app-hub-card>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <section
    class="u-paddingTop-32 u-marginTop-32 u-paddingBottom-32 u-textAlign-center u-margin-center"
  >
    <div class="u-paddingTop-32">
      <img
        [ngStyle]="{ 'max-width': '160px' }"
        i18n-alt="@@userOnboardingView.hubs.noCommunityFoundCards"
        alt="No community found cards"
        src="https://storage.googleapis.com/ttc-static-images/Empty%20State%20Illustrations/No%20content.FBE418A.png"
      />
    </div>
    <h5
      i18n="@@userOnboardingView.hubs.noCommunityFound"
      class="u-paddingTop-16 u-marginBottom-8 u-textDecoration-bold"
    >
      No community found
    </h5>
    <div
      i18n="@@userOnboardingView.hubs.reachOutToAdmin"
      class="color-grey-300 text-subtitle-1"
    >
      Reach out to your admin or 10KC support to join a community.
    </div>
    <div class="u-paddingTop-32">
      <button
        i18n="@@global.getSupport"
        (click)="showZendesk()"
        color="primary"
        mat-raised-button
      >
        Get support
      </button>
    </div>
  </section>
}
